(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"), require("module-content"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "ui", "module-content"], factory);
	else if(typeof exports === 'object')
		exports["widget-structured-content-abc"] = factory(require("base"), require("core"), require("ui"), require("module-content"));
	else
		root["widget-structured-content-abc"] = factory(root["base"], root["core"], root["ui"], root["module-content"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /*global define */

	/**
	                                  *  ----------------------------------------------------------------
	                                  *  Copyright © Backbase B.V.
	                                  *  ----------------------------------------------------------------
	                                  *  Author : Backbase R&D - Amsterdam - New York
	                                  *  Filename : main.js
	                                  *  ----------------------------------------------------------------
	                                  */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    module.name = 'widget-structured-content-abc';

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var ui = __webpack_require__(5);
	    var content = __webpack_require__(6);

	    var deps = [
	    core.name,
	    ui.name,
	    content.name];


	    // @ngInject
	    function run(lpCoreBus, lpWidget) {
	        if (lpWidget && lpWidget.model) {
	            lpCoreBus.publish('cxp.item.loaded', {
	                id: lpWidget.model.name });

	        }
	    }

	    return base.createModule(module.name, deps).
	    controller(__webpack_require__(7)).
	    run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /*global define */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    var CONTENT_REF_PREF = 'contentRef';
	    var LINK_BASE_PREF = 'linkBase';
	    var TEMPLATE_NAME = 'templateName';

	    var initDesignMode = function initDesignMode(ctrl, lpWidget) {
	        ctrl.saveContentRef = function (contentRef) {
	            lpWidget.setPreference(CONTENT_REF_PREF, contentRef);
	            lpWidget.model.save(function () {
	                lpWidget.refreshHTML();
	            });
	        };
	    };

	    /**
	        * Structured Content Controller
	        * @ngInject
	        */

	    exports.MainCtrl = function ($location, lpContentUtils, lpWidget, lpPortal, lpCoreI18n, lpCoreBus, lpCoreI18nUtils) {
	        var ctrl = this;
	        var contentRef = lpWidget.getPreference(CONTENT_REF_PREF);
	        var asyncContentRef = $location.url().replace(/^\//, '');
	        var linkBase = lpWidget.getPreference(LINK_BASE_PREF);
	        var templateName = lpWidget.getPreference(TEMPLATE_NAME);

	        ctrl.isMobileNative = lpWidget.getPreference('native') || false;

	        ctrl.initContentRef = contentRef;
	        if (asyncContentRef !== contentRef) {
	            ctrl.asyncContentRef = asyncContentRef;
	        }

	        if (templateName == 'contact' || templateName == 'register') {
	            $(lpWidget.htmlNode).closest(".pageContainer").addClass('page-grey-background');
	            $(lpWidget.htmlNode).closest("html").addClass('page-grey-background');

	            if (templateName == 'register') {

	                if ($(".download-links").find("a:not([href])").length > 0) {
	                    $(".download-links").find("a:not([href])").hide();
	                    $(".download-links a:nth-child(2)").css("padding-left", "0");
	                }
	                //$($(".register-content .box .download-links")[5]).css("color", '#1281ab');
	                //$($(".register-content .box .download-links")[2]).css("color", '#1281ab');
	                //$($($($(".register-content .box .download-links")[2]).find("a"))[0]).css("border","none");
	                //$($($($(".register-content .box .download-links")[2]).find("a"))[1]).hide();
	                /*if (window.sessionStorage.getItem("selected_locale") == 'en-US') {
	                    $($(".register-content .box .download-links")[5]).html("Coming soon");
	                }
	                else {
	                    $($(".register-content .box .download-links")[5]).html("Bientôt disponible");
	                }*/


	            }
	            setLocalization(window.sessionStorage.getItem("selected_locale"));
	        } else
	        if (templateName == 'terms') {
	            var data = {
	                englishTerms: $(lpWidget.htmlNode).find(".english-terms").html(),
	                frenchTerms: $(lpWidget.htmlNode).find(".french-terms").html(),
	                arabicTerms: $(lpWidget.htmlNode).find(".arabic-terms").html() };

	            lpCoreBus.publish('launchpad-retail.termsAndConditionsContent', data);
	        }

	        function setLocalization(locale) {
	            if (locale == 'en-US') {
	                $(".transalte-fr").hide();
	                $(".transalte-en").show();
	            } else
	            if (locale == 'fr-FR') {
	                $(".transalte-en").hide();
	                $(".transalte-fr").show();
	            }
	            $.getJSON(lpWidget.myDefinition.sUrl.replace("index.html", "locale/all.json"), function (data) {
	                $(".contact-data").text(data[locale]["abc.contact.footer"]);
	                $(".legal-notes").text(data[locale]["abc.contact.legal.note"]);
	                $(".translate-register-as").text(data[locale]["abc.register.as"]);
	                $(".translate-retail-customer").text(data[locale]["abc.register.retail.customer"]);
	                $(".translate-corporate-customer").text(data[locale]["abc.register.corporate.customer"]);
	            });
	            if ($(".register-content .box .download-links").length > 0) {
	                //$($($($(".register-content .box .download-links")[2]).find("a"))[0]).css("border","none");
	                //$($($($(".register-content .box .download-links")[2]).find("a"))[1]).hide();
	                /*if (locale == 'en-US') {
	                    $($(".register-content .box .download-links")[5]).html("Coming soon");
	                }
	                else {
	                    $($(".register-content .box .download-links")[5]).html("Bientôt disponible");
	                }*/
	            }
	        }

	        lpCoreBus.subscribe(lpCoreI18nUtils.LOCALE_CHANGE_EVENT, function (locale) {
	            setLocalization(locale);
	        });

	        if (linkBase) {
	            ctrl.link = lpPortal.root + '/' + linkBase + '#/' + contentRef;
	            $(lpWidget.htmlNode).find('.media a.media-link').attr('href', ctrl.link);
	            $(lpWidget.htmlNode).find('.media a.media-link-small').attr('href', ctrl.link);
	        }

	        if (lpContentUtils.isEditable(lpWidget)) {
	            initDesignMode(ctrl, lpWidget);
	        }

	        var acc = $(lpWidget.htmlNode).find(".accordion");
	        var i;

	        for (i = 0; i < acc.length; i++) {
	            acc[i].onclick = function () {
	                this.classList.toggle("active");
	                var panel = this.nextElementSibling;
	                if (panel.style.display === "block") {
	                    panel.style.display = "none";
	                } else {
	                    panel.style.display = "block";
	                }
	            };
	        }
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js